// this file added by Bearer Web Developer
import React from "react";
import styles from './noOrder.module.scss';
import { useThemeMode } from "../../../states/contexts/theme";

const NoOrder: React.FC = () => {

    const { theme } = useThemeMode();
    return (
        <div className={styles.no_order_part} data-theme={theme}>
            <div className={styles.no_order}>
                <img src={theme === "dark" ? "/caught-up-white.svg" : "/caught-up.svg"} alt="" />
                <p>You're all caught up.</p>
            </div>
        </div>
    )
};
export default NoOrder;